<app-gtag-metric *ngIf="googleTagManagerCodes$ | async as codes" [codes]="codes"></app-gtag-metric>
